<template>
  <div prop="variable" class="sky-batch-product-upgrade wsp-line-height-28">
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>升级场景</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-display-flex wsp-width-100">
        <div class="wsp-width-10 wsp-display-flex-center"><label>场景名称：</label></div>
        <div class=" wsp-width-80 wsp-display-flex-center" style="display: inline-block;">
          <span v-for="(item, index) in variable.upgradeSceneList" :key="index">
            {{ item.sceneName }}
            <span v-if="index < variable.upgradeSceneList.length - 1">；</span>
          </span>
        </div>
      </div>
    </div>
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>产品版本</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12" v-for="(item, index) in variable.upgradeProductList" :key="index">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-50">
          {{ item.productVersion }}
        </div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-65">
          <el-select
            placeholder="请选择目标产品版本"
            clearable
            v-model="item.targetProductId"
            filterable
            style="width: 100% !important;"
            @change="productChange"
          >
            <el-option v-for="(item, index) in productList" :key="index" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div style="color: red;">{{ message }}</div>
    <div style="text-align: center;">
      <el-button
        :loading="loading"
        :disabled="loading"
        type="primary"
        class="sky-branch-pattern__add"
        style="margin-top:5px"
        @click="onConfirm"
      >
        确定
      </el-button>
      <el-button :disabled="loading" class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button, MessageBox } from 'element-ui'
import { action } from 'sky-engine/api'

import { SCENE_MNG, PRODUCT_MNG } from '@/api/apiModules'
import lang from '@/lang'

export default {
  name: 'SkyBatchProductUpgrade',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    industryId: null,
    scenes: {}
  },
  data() {
    return {
      loading: false,
      message: null,
      productList: [],
      variable: {
        upgradeSceneList: [],
        upgradeProductList: []
      }
    }
  },
  created() {
    if (!this.scenes) {
      return
    }

    this.variable.upgradeSceneList = this.scenes.upgradeSceneList
    this.variable.upgradeProductList = this.scenes.upgradeProductList
  },
  mounted() {
    action(PRODUCT_MNG, 'findAllActive').then(response => {
      this.productList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
  },
  watch: {},
  methods: {
    productChange() {
      this.isFill()
    },
    isFill() {
      this.message = ''
      if (this.variable && this.variable.upgradeProductList) {
        const cnt = this.variable.upgradeProductList.filter(item => item.targetProductId != null).length
        if (cnt === 0) {
          this.message = '请选择至少一个目标产品版本'
          return false
        }
        for (const obj of this.variable.upgradeProductList) {
          if (obj.id == obj.targetProductId) {
            this.message = '目标产品版本不能与源产品版本相同'
            return false
          }
        }
      }
      if (this.variable && this.variable.upgradeProductList?.length > 1) {
        const ids = this.variable.upgradeProductList
          .filter(item => {
            return item.targetProductId != null
          })
          .map(item => item.targetProductId)
        const hasDuplicate = new Set(ids).size !== ids.length

        if (hasDuplicate) {
          this.message = '目标产品版本不能重复'
          return false
        }
      }
      return true
    },
    onConfirm() {
      if (!this.isFill()) return
      MessageBox.confirm('此操作不可回退，确认要进行批量产品升级吗？', lang.t('sk.tip'), {
        confirmButtonText: lang.t('confirm'),
        cancelButtonText: lang.t('cancel'),
        type: 'warning'
      }).then(({ value }) => {
        this.loading = true
        const scenes = this.variable.upgradeSceneList.map(item => {
          return item.id
        })
        const products = this.variable.upgradeProductList
          .filter(item => item.targetProductId != null)
          .map(item => {
            return { sourceProductId: item.id, targetProductId: item.targetProductId }
          })
        const params = { industryId: this.industryId, sourceSceneIdList: scenes, productUpgradeList: products }
        action(SCENE_MNG, 'batchProductUpgrade', params)
          .then(response => {
            this.$emit('cb')
            this.$store.dispatch('OpenNotification', {
              message: '批量升级产品版本成功',
              type: 'success'
            })
          })
          .catch(e => {
            this.loading = false
            throw e
          })
      })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(batch-product-upgrade) {
  margin-bottom: 0px !important;
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(multiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .item-title {
    width: 31%;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
